import { createAxios, logNative } from '../../utils/utils';
import {
  ZT_VIEW_PAGE_70,
  GROUNP_CONTENT_53,
  GET_SPECIAL_INFO_55,
  SPECIAL_ZAN_70,
  SPECIAL_COLLECT_SET_72,
  SPECIAL_COLLECT_CANCEL_72,
} from '../../config';
import Toast from '../../components/Toast/Toast';
import styles from './NSpecial.module.less';
import React from 'react';
export default {
  async getSpecialInfo({ ztId, viewPage }) {
    try {
      const url = viewPage === '1' ? ZT_VIEW_PAGE_70 : GET_SPECIAL_INFO_55;
      const param = viewPage === '1' ? { ztId, viewPage } : { ztId };
      const axios = await createAxios('isNeedUser');
      const res = await axios.get(url, { params: param });
      if (res.data.status === 0) {
        return {
          ...res.data.data,
          isOffLine: false,
        };
      } else {
        return {
          ztId,
          isOffLine: true,
        };
      }
    } catch (error) {
      return error;
    }
  },
  async getSpecialListBySource(params) {
    try {
      const axios = await createAxios();
      const res = await axios.get(GROUNP_CONTENT_53, {
        params,
      });
      if (res.data.status === 0) {
        return res.data.data;
      }
    } catch (err) {
      logNative(`根据页面来源类型获取专题列表数据失败${err}`, err);
    }
  },
  async setSpecialZan(payload, specialInfo) {
    try {
      const axios = await createAxios();
      const res = await axios.get(SPECIAL_ZAN_70, {
        params: payload,
      });
      if (res && res.data && res.data.status === 0) {
        Toast.success({
          content: '点赞成功！',
        });
        return {
          ...specialInfo,
          hasZan: 1,
          zanCount: (+specialInfo.zanCount || 0) + 1,
        };
      } else {
        Toast.error({
          content: '点赞失败！',
        });
        return specialInfo;
      }
    } catch (err) {
      Toast.error({
        content: '点赞失败！',
      });
      logNative(`增加专题页面点赞数${err}`, err);
      return specialInfo;
    }
  },
  async addCollectSpecial(param, specialInfo) {
    const axios = await createAxios('isNeedUser');
    const res = await axios.get(SPECIAL_COLLECT_SET_72, {
      params: param,
    });

    try {
      if (res && res.data && res.data.status === 0) {
        Toast.success({
          content: '收藏成功!',
        });
        // 专题

        return {
          ...specialInfo,
          hasCollect: 1,
          collectCount: ((specialInfo && specialInfo.collectCount) || 0) + 1,
        };
      } else {
        Toast.error({
          content: '收藏失败!',
        });
        return specialInfo;
      }
    } catch (err) {
      logNative(err);
      return specialInfo;
    }
  },

  async deleteCollectSpecial(payload, specialInfo) {
    const axios = await createAxios('isNeedUser');
    const res = await axios.get(SPECIAL_COLLECT_CANCEL_72, {
      params: payload,
    });
    try {
      if (res && res.data && res.data.status === 0) {
        Toast.success({
          content: <div className={styles.toast}>取消收藏成功!</div>,
          className: styles.toast_img,
        });

        return {
          ...specialInfo,
          hasCollect: 0,
          collectCount: (specialInfo && specialInfo.collectCount) - 1 || 0,
        };
      } else {
        Toast.error({
          content: <div className={styles.toast}>取消收藏失败!</div>,
          className: styles.toast_img,
        });
        return specialInfo;
      }
    } catch (err) {
      logNative(err);
      return specialInfo;
    }
  },
};
